import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

let lenis = null;

export const SmoothScroll = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.querySelector(hash) : null;
      if (el && lenis) lenis.scrollTo(el, { offset: -80 });
      else if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, hash ? 300 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};
